import List from './list/ReferralIntentListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})